var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',_vm._b({attrs:{"min-height":"74.5vh"}},'v-card',_vm.$attrs,false),[(_vm.loading)?[_c('v-overlay',{attrs:{"absolute":"","opacity":"0"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"32"}})],1)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }